import { useEffect, useState } from "react";
import { Moon, Sun, Monitor } from "lucide-react";

type Theme = "light" | "dark" | "system";
const valid = (value: string | null): value is Theme =>
  ["light", "dark", "system"].includes(value || "");
export function applyTheme() {
  let choice: Theme = "system";
  try {
    const saved = localStorage.getItem("gdtool-theme");
    if (valid(saved)) choice = saved;
  } catch {}
  const dark =
    choice === "dark" ||
    (choice === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", dark ? "#171b25" : "#f7f8fb");
  return choice;
}
applyTheme();
export function ThemePicker() {
  const [theme, setTheme] = useState<Theme>(applyTheme);
  useEffect(() => {
    const update = () => setTheme(applyTheme());
    const media = matchMedia("(prefers-color-scheme: dark)");
    window.addEventListener("storage", update);
    window.addEventListener("gdtool-theme", update);
    media.addEventListener("change", update);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("gdtool-theme", update);
      media.removeEventListener("change", update);
    };
  }, []);
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : Monitor;
  return (
    <label className="theme-picker">
      <Icon size={15} />
      <select
        aria-label="Тема оформления"
        value={theme}
        onChange={(e) => {
          try {
            localStorage.setItem("gdtool-theme", e.target.value);
          } catch {}
          setTheme(e.target.value as Theme);
          applyTheme();
          window.dispatchEvent(new Event("gdtool-theme"));
        }}
      >
        <option value="system">Как в системе</option>
        <option value="light">Светлая</option>
        <option value="dark">Тёмная</option>
      </select>
    </label>
  );
}
